const CARD_SELECTOR = '.vf-product-card';
const SWATCH_SELECTOR = '[data-vf-card-swatch]';

function selectCardSwatch(swatch) {
  const card = swatch.closest(CARD_SELECTOR);
  if (!card || !(swatch instanceof HTMLElement)) return;

  const variantId = swatch.dataset.variantId;
  if (!variantId) return;

  card.dataset.vfSelectedVariantId = variantId;
  card.querySelector('vf-card-add')?.selectVariant?.(variantId);
  card.querySelectorAll(SWATCH_SELECTOR).forEach((item) => {
    const selected = item === swatch;
    item.classList.toggle('is-selected', selected);
    item.setAttribute('aria-pressed', String(selected));
  });

  card.querySelectorAll('input[name="id"]').forEach((input) => {
    input.value = variantId;
  });

  const image = card.querySelector('.vf-product-card__media img');
  const mediaUrl = swatch.dataset.mediaUrl;
  if (image instanceof HTMLImageElement && mediaUrl) {
    image.src = mediaUrl;
    image.removeAttribute('srcset');
  }
}

document.addEventListener('click', event => {
  const swatch = event.target instanceof Element ? event.target.closest(SWATCH_SELECTOR) : null;
  if (!swatch) return;
  event.preventDefault();
  event.stopPropagation();
  selectCardSwatch(swatch);
}, true);

document.addEventListener('keydown', event => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  const swatch = event.target instanceof Element ? event.target.closest(SWATCH_SELECTOR) : null;
  if (!swatch) return;
  event.preventDefault();
  selectCardSwatch(swatch);
});
